const walletData = {
  rechargeAmount: {
    key: "rechargeAmount",
    label: "Recharge Amount",
    type: "number",
    isRequired: true,
  },
};

export { walletData };
